export default __webpack_public_path__ + "static/media/icon-twitter.754800a3.svg";